import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableCell, TableContainer, TableHead, TableBody, Paper, TableRow, Typography} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getStores } from "./../../../store/actions";
import Loading from "./../Loading";

const styles = makeStyles({
  table: {
    minWidth: 700,
  },
});

const GetStores = () => {
  const [storeData, setStoreData] = useState([]);
  const classes = styles();
  const dispatch = useDispatch();
  const { request, stores, error } = useSelector((state: any) => {
    return state;
  });
  useEffect(() => {
    setStoreData(stores);
  }, [stores]);

  useEffect(() => {
    dispatch(getStores());
  }, []);

  return (
    <>
    {error && (
        <Typography variant="h5" component="h2" gutterBottom align="center">
          An error occured please try again
        </Typography>
      )}
      {request ? (
        <Loading />
      ) : (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="Stores table">
        <TableHead>
          <TableRow>
            <TableCell>Store Name</TableCell>
            <TableCell align="left">Store Owner</TableCell>
            <TableCell align="center">Phone Number</TableCell>
            <TableCell align="left">Address</TableCell>
            <TableCell align="right">Categories</TableCell>
          </TableRow>
          </TableHead>
          <TableBody>
           {storeData.length ? (
             storeData.map((row) => {
               const address = `${row.attributes.address}, ${row.attributes.city}. ${row.attributes.state}`;
               const categories = row.attributes.product_categories;
               return(
            <TableRow key={row.id}>
              <TableCell component="th" scope="row">
                {row.attributes.store_name}
              </TableCell>
              <TableCell align="left">{row.attributes.store_owner}</TableCell>
              <TableCell align="center">{row.attributes.phone_no}</TableCell>
              <TableCell align="left">
              <Typography variant="subtitle2">
                {address}
              </Typography>
              </TableCell>
              <TableCell align="right">{categories}</TableCell>
            </TableRow>
             )}
        )): (  <><TableRow>
                 <TableCell align="center">No data yet</TableCell>
               </TableRow></>
             )
        }
      </TableBody>
      </Table>
    </TableContainer>
    )}
   </>
   )
}
export default GetStores;